export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX_RUS = /^(8|\+7)[\- ]??(\(?\d{3}\)?[\- ]?)?[\d\- ]{10}$/;
// export const PHONE_REGEX_INT = /^\+[0-9]?()[0-9](\s|\S)(\d[0-9]{9})$/;
export const PHONE_REGEX_INT = /(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})/g;

/* Валидация успешна */
export const validateSuccess = input => {
    input.classList.add('js-valid');
    input.classList.remove('js-invalid');
};

/* Валидация неуспешна */
export const validateError = input => {
    input.classList.remove('js-valid');
    input.classList.add('js-invalid');
};

/* Убрать валидацию */
export const validateRemove = input => {
    input.classList.remove('js-valid');
    input.classList.remove('js-invalid');
};

/* Показать/скрыть доп. информацию для методов доставки */
export const toggleElements = (elementsToShow, elementsToHide) => {
    const switchClassName = (node, className, action) => {
        switch (action) {
            case 'show':
                !node.classList.contains(className)
                    ? node.classList.add(className)
                    : null;
                break;
            case 'hide':
                node.classList.contains(className)
                    ? node.classList.remove(className)
                    : null;
                break;
        }
    };

    if (Array.isArray(elementsToShow)) {
        for (let i = 0; i < elementsToShow.length; i++) {
            const el = elementsToShow[i];
            switchClassName(el, 'visible', 'show');
        }
    } else if (elementsToShow) {
        switchClassName(elementsToShow, 'visible', 'show');
    }

    if (Array.isArray(elementsToHide)) {
        for (let i = 0; i < elementsToHide.length; i++) {
            const el = elementsToHide[i];
            switchClassName(el, 'visible', 'hide');
        }
    } else if (elementsToHide) {
        switchClassName(elementsToHide, 'visible', 'hide');
    }
};

/* Добавить значок валюты */
export const toPrice = str => {
    const { currency, currencyRate, currencySymbol } = MNTK;
    let locale = 'ru';
    if (currency === 'USD') {
        locale = 'us';
    }
    if (currency === 'EUR') {
        locale = 'eu';
    }
    const price = parseFloat(str) / currencyRate;
    const priceHtml = price
        .toLocaleString(locale, {
            currency,
            maximumFractionDigits: 2,
            minimumFractionDigits: 0
        })
        .replace(' ', '&nbsp;');
    switch (currency) {
        case 'RUB':
        case 'EUR':
            return `${priceHtml}&nbsp;${currencySymbol}`;
        case 'BYN':
            return `${priceHtml}${currencySymbol}`;
        default:
            return `${currencySymbol}${priceHtml}`;
    }
};

/* Показать HTML-элемент */
export const showElement = element => {
    element?.classList.remove('hidden');
};

/* Скрыть HTML-элемент */
export const hideElement = element => {
    element?.classList.add('hidden');
};

/* Изменить HTML элемента */
export const setHtml = (element, html) => {
    if (Array.isArray(element)) {
        for (let i = 0; i < element.length; i++) {
            const el = element[i];
            el.innerHTML = html;
        }
    } else {
        element.innerHTML = html;
    }
};

export const isJSON = str => {
    try {
        const result = JSON.parse(str);

        if (result && typeof result === 'object') {
            return result;
        }
    } catch (e) {
        return false;
    }
};

/* Обработка ошибок от сервера */
export const handleServerError = reject => {
    console.error(reject);

    // может прийти JS-объект с ошибкой,
    // либо HTML с описанием ошибки от Symfony
    if (reject instanceof Object) {
        let message;

        // TODO: привести к однообразному виду
        // для метода makeRequest
        if (reject.hasOwnProperty('responseText')) {
            const { error } = isJSON(reject.responseText);
            message = error;
            // для метода fetchJson
        } else if (reject.hasOwnProperty('xhr')) {
            const { error } = isJSON(reject.xhr.responseText);
            message = error;
        }

        window.openMessageModal(message ? message : '', 'Произошла ошибка!');
    } else {
        window.openMessageModal();
    }
};

// export const autoFillBuyerPhone = ($input, value, isRussia) => {
//     if (
//         (!isRussia && value) ||
//         (isRussia && PHONE_REGEX_RUS.test(value.trim()))
//     ) {
//         validateSuccess($input);
//     }
// };

export const autoFillBuyerEmail = ($input, value) => {
    if (EMAIL_REGEX.test(`${value.trim()}`)) {
        $input.value = value;
        validateSuccess($input);
    }
};

// определяем шаг, на котором пользователь прекратил оформление заказа
export const activeStep = () => {
    const checkoutSteps = Array.from(
        document.querySelectorAll('.p-checkout__cart')
    );
    const visibleSteps = checkoutSteps.filter(step =>
        step.classList.contains('visible')
    );
    const lastVisibleStep =
        visibleSteps[visibleSteps.length - 1] ||
        document.getElementById('initial');

    switch (lastVisibleStep.id) {
        case 'initial':
            return 'Шаг 1. Необходимые сведения';
        case 'payment':
            return 'Шаг 2. Выбор способа оплаты';
        case 'delivery':
            return 'Шаг 3. Выбор способа доставки';
        case 'information':
            return 'Шаг 4. Дополнительные сведения';
    }
};
